function hasStableValue (value) {
  return value !== undefined && value !== null && value !== ''
}

function firstStableValue (...values) {
  for (const value of values) {
    if (hasStableValue(value)) {
      return value
    }
  }
  return undefined
}

function buildTooltipRemarkStorageKey (item) {
  if (!item || !item.type) {
    return ''
  }

  if (item.type === 'signLabel') {
    const signIndex = firstStableValue(item.signIndex)
    if (hasStableValue(signIndex)) {
      return `sign:${signIndex}`
    }

    const signName = firstStableValue(item.signName, item.name)
    return hasStableValue(signName) ? `sign:${signName}` : ''
  }

  if (item.type === 'houseSector') {
    const houseNumber = firstStableValue(item.houseNumber)
    return hasStableValue(houseNumber) ? `house:${houseNumber}` : ''
  }

  const id = firstStableValue(item.id)
  return hasStableValue(id) ? `${item.type}:${id}` : ''
}

module.exports = {
  buildTooltipRemarkStorageKey
}
